module.exports = __webpack_public_path__ + "media/images/emblems/Lussery-Villars-coat_of_arms-332432d9d0bdcd4b5881533fa433a7b0.svg";